import classNames from 'classnames';
import type { Notario } from '@/interfaces/strapi';
import CTNIcon from '@ctn/ui/components/ctn-icon/icon';
import { MapEmbed } from '@/components';

type NotariosListItemProps = {
	readonly className?: string;
	readonly notario: Notario;
};

const classNameComponent = 'c-cnm-notarios-card';

export const NotariosListItem = ({ className, notario }: NotariosListItemProps) => {
	const wrapperClassName = classNames(classNameComponent, className);

	return (
		<article className={wrapperClassName}>
			<div className={`${classNameComponent}__grid`}>
				<div className={`${classNameComponent}__info`}>
					<h4 className={`${classNameComponent}__name`}>{notario.name}</h4>
					{notario.notariaAddress && (
						<div className={`${classNameComponent}__info-row`}>
							<CTNIcon icon="home" />
							<span className={`${classNameComponent}__text`}>
								{notario.notariaAddress}{' '}
								{notario.notariaMunicipio ? `(${notario.notariaMunicipio})` : ''}
							</span>
						</div>
					)}

					{(notario.telefonoNotaria1 || notario.telefonoNotaria2) && (
						<div className={`${classNameComponent}__info-row`}>
							<CTNIcon icon="call" />
							<span className={`${classNameComponent}__text`}>
								{[notario.telefonoNotaria1, notario.telefonoNotaria2].filter(Boolean).join(' - ')}
							</span>
						</div>
					)}

					{notario.faxNotaria && (
						<div className={`${classNameComponent}__info-row`}>
							<CTNIcon icon="print" />
							<span className={`${classNameComponent}__text`}>{notario.faxNotaria}</span>
						</div>
					)}

					{notario.emailCorporativo && (
						<div className={`${classNameComponent}__info-row`}>
							<CTNIcon icon="mail" />
							<span className={`${classNameComponent}__text`}>{notario.emailCorporativo}</span>
						</div>
					)}
				</div>
				<div className={`${classNameComponent}__map`}>
					<MapEmbed address={`${notario.notariaAddress ?? ''} ${notario.notariaMunicipio ?? ''}`} />
				</div>
			</div>
		</article>
	);
};
